import { render, staticRenderFns } from "./ConfigChips.vue?vue&type=template&id=160d1c3d&scoped=true&"
import script from "./ConfigChips.vue?vue&type=script&lang=js&"
export * from "./ConfigChips.vue?vue&type=script&lang=js&"
import style0 from "./ConfigChips.vue?vue&type=style&index=0&id=160d1c3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160d1c3d",
  null
  
)

export default component.exports